import React, { useCallback, useMemo } from 'react';

import { PaymentMethodLayout } from '@/modules/transaction/components/ReimburseMe/ConfirmationStep/Immediately/ChoosePaymentMethod/paymentMethodLayout.types';
import Immediately, { StepsStates } from '@/modules/transaction/components/ReimburseMe/ConfirmationStep/Immediately/Immediately';
import { useGetPaymentMethods } from '@/modules/transaction/components/ReimburseMe/queries/useGetPaymentMethods.query';
import { useStore } from '@/modules/transaction/components/ReimburseMe/store/usePaymentMethods.store';
import { PaymentMethod } from '@/modules/transaction/components/ReimburseMe/types/payment.types';
import { useOrganizationProperties } from '@/modules/transaction/hooks';
import { useAuthStore } from '@/modules/user';
import { PaymentMethodType } from '@/modules/user/user.types';

const PaymentMethodChoosing: React.FC<{ isRejectionFlow?: boolean }> = ({ isRejectionFlow }) => {
  const { user } = useAuthStore();
  const employeeId = useMemo(() => {
    return user?.employee?.id || ''; 
  }, [user?.employee?.id]);
  const { organizationProperties } = useOrganizationProperties();
  const allowedPaymentMethodConfigs = useMemo(() => organizationProperties?.allowedPaymentMethodConfigs
    ?.filter((item) => item?.paymentMethodType === PaymentMethodType.DIRECT_DEPOSIT),
  [organizationProperties]);
  const handleSetPaymentMethods = useStore((state) => state.handleSetPaymentMethods);
  const handleGettingPaymentMethods = useCallback((paymentMethods: PaymentMethod[]) => {
    handleSetPaymentMethods(
      paymentMethods
        .filter(
          (method) => method?.paymentMethodOwner?.employeeId === employeeId,
        ),
    );
  }, [employeeId, handleSetPaymentMethods]);
  const { isLoading } = useGetPaymentMethods(handleGettingPaymentMethods);
  return (
    <Immediately
      isLoading={isLoading}
      type="full"
      allowedPaymentMethodConfigs={allowedPaymentMethodConfigs}
      defaultStep={StepsStates.depositOrDebit}
      isUnwrapped
      isRejectionFlow={isRejectionFlow}
      paymentMethodLayout={PaymentMethodLayout.Divider}
    />
  );
};

export default PaymentMethodChoosing;
